import { z } from 'zod';

export const MeSchema = z.object({
  userId: z.number(),
  clientId: z.number(),
  isAdminUser: z.boolean(),
});
